import { render, staticRenderFns } from "./RateCardBreakEditForm.vue?vue&type=template&id=54b2a084&"
import script from "./RateCardBreakEditForm.vue?vue&type=script&lang=js&"
export * from "./RateCardBreakEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports